/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Services\RouterService\RouterService.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday October 8th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday October 8th 2024 4:13:24 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

export function ExtractQueryInObj(request: Request) {
    const searchParams = new URL(request.url).searchParams;
    let tmp: any = {};
    for (let entry of searchParams.entries())
        tmp[entry[0]] = entry[1];
    return tmp;
};
